import Barchart from "./Barchart"
import React, { useState, useEffect } from 'react';
import ClipLoader from 'react-spinners/ClipLoader';

function SeasonalMovement({setloading10, year}){
    const [airportsSeasonalData, setairportsSeasonalData] = useState(null);
    const [airportsSeasonalOptions, setairportsSeasonalOptions] = useState({});


    const [excelDataChart6,setexcelDataChart6] = useState();
  
  
    useEffect(() => {
      var url = "api/topairportswithseasonalmovements/" + year;
  
      fetch(url).then((res) =>
        res.json().then((res) => {
          
          let previous_year = year - 1;
          
          // Transform list to the proper form
          const listForPrevYear = res.data[previous_year.toString()]
          const listForThisYear = res.data[year.toString()]
          
          for (const obj of listForPrevYear) {
            obj["Έτος"] = previous_year;
          }
          
          for (const obj of listForThisYear) {
            obj["Έτος"] = year;
          }

          const FinList = [...listForPrevYear, ...listForThisYear];
          setexcelDataChart6(FinList);
          
          const listOfIds = res.data[previous_year.toString()].map((airport, i) => {
            return  airport["Αεροδρόμιο"];
            // res.data[previous_year.toString()][i]
          });
          
          const listOfValues = res.data[previous_year.toString()].map((airport, i) => {
            return  airport["Συντελεστής Gini"];
            // res.data[previous_year.toString()][i]
          });
          

          //isws airport anti gia res....
          const listOfValues2 = res.data[year.toString()].map((airport, i) => {
            return  airport["Συντελεστής Gini"];
            // res.data[year.toString()][i]
          });


          
  
  
          //Set options for Plot
          setairportsSeasonalData({
            labels: listOfIds,
            datasets: [
              {
                label: previous_year,
                data: listOfValues,
                backgroundColor: '#13A2DE',
                barPercentage: 0.8,
                categoryPercentage: 0.5,
        
              },
              {
                label: year,
                data: listOfValues2,
                backgroundColor: "#75D1D8",
                barPercentage: 0.8,
                categoryPercentage: 0.5,
              },
            ],
          })
      
          setairportsSeasonalOptions({
            maintainAspectRatio: false,
            responsive: true,
            plugins: {
              legend: {
                position: 'bottom',
              },
            },
            scales: {
              // y: {
              //   suggestedMin: 0,
              //   max: 1
              // },
            }
          })
          setloading10(false)
  
         })
        )
      .catch((error) => {
        console.log("Refetching data for Top10 most efficient greek airports!")
      })
  
   
  
    }, [year, setloading10]);


    return(
      airportsSeasonalData ? 
        <Barchart chartData={airportsSeasonalData} chartOptions = {airportsSeasonalOptions} excelData ={excelDataChart6}></Barchart>
      :  <ClipLoader size={100} color={'#123abc'} loading={true}/>  
        
        
    )
}




export default SeasonalMovement;